<!doctype html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover" />
  <meta name="theme-color" content="#07111f" />
  <meta name="description" content="Neon Road Patrol is a futuristic Singapore-vibes road awareness game for drivers and pedestrians." />
  <meta property="og:title" content="Neon Road Patrol" />
  <meta property="og:description" content="Point out traffic issues, protect pedestrians, learn signals, and climb the local leaderboard." />
  <title>Neon Road Patrol</title>
  <link rel="icon" href="/roadpatrol/favicon.svg" type="image/svg+xml" />
</head>
<body>
  <div id="app"></div>
  <script type="module" src="/src/main.ts"></script>
</body>
</html>
